import i18next from "i18next";

const getDSLanguage = (lng = '') => {
  if (lng.includes('en')) {
    return 'en';
  }

  if (lng.includes('fr')) {
    return 'fr';
  }

  return 'en';
};

export const openDSWindow = ({
  url,
  name,
}) => {
  const origin = window.location.origin;
  const token = sessionStorage.getItem('proxy_token');

  const win = window.open(
    `${origin}${url}?proxy_token=${token}`,
    name,
    'height=900,width=1578',
  );

  return win;
};

export const openArmWindow = ({
  url,
  name,
}) => {
  const armUrl = new URL(`${process.env.REACT_APP_ARM_URL}${url}`);
  armUrl.searchParams.append('language', getDSLanguage(i18next.language));

  const win = window.open(
    armUrl.toString(),
    name,
    'height=900,width=1578',
  );

  return win;
};
